import React from 'react';

const steps = [
  {
    id: 'step-choose',
    number: '01',
    icon: '🎯',
    title: 'Choisissez votre formule',
    text: 'Sélectionnez audio ou vidéo, 15 ou 45 minutes selon vos besoins et votre budget.',
  },
  {
    id: 'step-book',
    number: '02',
    icon: '📅',
    title: 'Réservez en ligne',
    text: 'Remplissez le formulaire ci-dessus. Marc confirme votre séance sous 24h par email.',
  },
  {
    id: 'step-speak',
    number: '03',
    icon: '🗣️',
    title: 'Parlez anglais',
    text: 'Rejoignez la session. Parlez. Progressez. C\'est aussi simple que ça.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 lg:py-20 bg-background">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="text-center mb-12">
          <p className="section-label mb-3">Comment ça marche</p>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-primary">Simple. Direct. Efficace.</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-10 max-w-4xl mx-auto relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-10 left-[calc(33.33%+1rem)] right-[calc(33.33%+1rem)] h-0.5 bg-gradient-to-r from-accent/40 via-accent to-accent/40" />

          {steps?.map((step) => (
            <div key={step?.id} className="text-center relative">
              <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-2xl navy-gradient mb-4 shadow-card">
                <span className="text-3xl">{step?.icon}</span>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent rounded-full flex items-center justify-center">
                  <span className="text-xs font-bold text-primary">{step?.number}</span>
                </div>
              </div>
              <h3 className="text-lg font-bold text-primary mb-2">{step?.title}</h3>
              <p className="text-sm text-secondary leading-relaxed">{step?.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}